var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56199 8.30382C7.56199 8.9977 7.83764 9.66317 8.32829 10.1538C8.81894 10.6445 9.48441 10.9201 10.1783 10.9201C10.8722 10.9201 11.5377 10.6445 12.0283 10.1538C12.519 9.66317 12.7946 8.9977 12.7946 8.30382C12.7946 7.60993 12.519 6.94446 12.0283 6.4538C11.5377 5.96315 10.8722 5.6875 10.1783 5.6875C9.48441 5.6875 8.81894 5.96315 8.32829 6.4538C7.83764 6.94446 7.56199 7.60993 7.56199 8.30382ZM20.3212 7.70113C18.1067 3.03615 14.7592 0.688477 10.2717 0.688477C5.78196 0.688477 2.43682 3.03615 0.222295 7.70346C0.13347 7.89155 0.0874023 8.09698 0.0874023 8.30498C0.0874023 8.51299 0.13347 8.71841 0.222295 8.9065C2.43682 13.5715 5.7843 15.9192 10.2717 15.9192C14.7615 15.9192 18.1067 13.5715 20.3212 8.90417C20.5011 8.52574 20.5011 8.08657 20.3212 7.70113ZM10.1783 12.4152C7.90772 12.4152 6.06695 10.5744 6.06695 8.30382C6.06695 6.03323 7.90772 4.19247 10.1783 4.19247C12.4489 4.19247 14.2897 6.03323 14.2897 8.30382C14.2897 10.5744 12.4489 12.4152 10.1783 12.4152Z",
    fill: "#21304280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.f4e75e57.svg";
export { ForwardRef as ReactComponent };